import type { ReactElement } from "react";

import TypographyPro from "themes/TypographyPro"
import {getTranslatedTextByKey} from "utils/language";

import { EditingRow as StyledEditingRow, EditingRowContainer, EditingRowTitle, EditingRowSubTitle, EditingRowSubTitleRow, EditingRowIconContainer, EditingRowAction, EditingRowActionText } from "../style";

const EditingRow = ({title, description, additionnalInfo = null, icon = null, action} : {title: string, description: string, additionnalInfo: string | null, icon: ReactElement | null, action: undefined | (() => Promise<void>) | (() => void)}) => (
        <StyledEditingRow data-testid={`${title}-row`}>
            <EditingRowContainer>
                <EditingRowTitle variant="Subhead">{title}</EditingRowTitle> 
                {icon && 
                    <EditingRowSubTitle>
                        <EditingRowSubTitleRow>
                            <EditingRowIconContainer>{icon}</EditingRowIconContainer>
                            <TypographyPro variant="Subhead">{description}</TypographyPro>
                        </EditingRowSubTitleRow>
                        {additionnalInfo &&
                            <EditingRowSubTitleRow>
                                <EditingRowIconContainer />
                                <EditingRowTitle variant="Subhead">{additionnalInfo}</EditingRowTitle>
                            </EditingRowSubTitleRow>
                        }
                    </EditingRowSubTitle>
                }
                {!icon && 
                    <TypographyPro variant="Subhead">{description}</TypographyPro>
                }
            </EditingRowContainer>
            
            <EditingRowAction data-testid="edit-button" visible={action !== undefined}>
                <EditingRowActionText onClick={action} variant="CTASmall">{getTranslatedTextByKey('btns.edit', 'Change')}</EditingRowActionText>
            </EditingRowAction>
        </StyledEditingRow>
    )

export default EditingRow